// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageSwitchButtons-module--container--1HGJl","button":"ImageSwitchButtons-module--button--3ahAO","selected":"ImageSwitchButtons-module--selected--6RlnP"};